module.exports = __webpack_public_path__ + "img/146.8.b7001b48.png";